import {
  BlockedDateRange,
  isValidRangeDate,
} from '@/components/inputs/dateRangeValidation';
import { TrackingIcon, TrackingIconSlot } from '../models';

export const trackingIconBlockedRanges = (
  icons: TrackingIcon[],
  slot: TrackingIconSlot,
  excludeId?: string
): BlockedDateRange[] =>
  icons
    .filter(
      (icon) =>
        icon.slot === slot &&
        icon.enabled &&
        !icon.isDefault &&
        icon.id !== excludeId
    )
    .map((icon) => {
      const from = icon.dateFrom ? new Date(icon.dateFrom) : null;
      const to = icon.dateTo ? new Date(icon.dateTo) : null;
      if (
        (from && !isValidRangeDate(from)) ||
        (to && !isValidRangeDate(to)) ||
        (from && to && from >= to)
      ) {
        throw new Error('No se pudo interpretar la disponibilidad');
      }
      return { id: icon.id, label: icon.name, from, to };
    });

export const trackingIconEnabledDefault = (
  icons: TrackingIcon[],
  slot: TrackingIconSlot,
  excludeId?: string
): TrackingIcon | undefined =>
  icons.find(
    (icon) =>
      icon.slot === slot &&
      icon.enabled &&
      icon.isDefault === true &&
      icon.id !== excludeId
  );
